var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "table",
      staticClass: "c-table",
      class: {
        "c-table_scrolled": _vm.isScrolled,
        "c-table_scrolled_right":
          !_vm.isScrollEnd && !_vm.data.actions && _vm.isScroll,
        "c-table_scroll_end": _vm.isScrollEnd,
        "c-table_scroll": _vm.isScroll,
      },
    },
    [
      _c("m-description", { ref: "description" }),
      _vm.displayShadow
        ? _c("div", {
            class: {
              "c-table__shadow": _vm.data.actions,
              "c-table__shadow__finance": _vm.data.type === "finance",
              "c-table__shadow__inventory-items-positions":
                _vm.data.type === "inventory-items-positions",
              "c-table__shadow__documents":
                _vm.data.type === "documents-archive" ||
                _vm.data.type === "documents-acting-documents",
              "c-table__shadow_active": _vm.data.actions,
              // 'c-table__empty__shadow': data.isGroupByCategory && hideCollapseGroups.length === data.records.length
            },
          })
        : _vm._e(),
      _vm.isScroll
        ? _c("div", { staticClass: "c-table__scrollbar-wrapper" })
        : _vm._e(),
      _c(
        "perfect-scrollbar",
        {
          ref: "wrapper" + (_vm.id !== undefined ? _vm.id : ""),
          staticClass: "c-table__wrapper",
          on: { scroll: _vm.scroll },
        },
        [
          _c(
            "table",
            { ref: "container", staticClass: "c-table__container" },
            [
              _c(
                "thead",
                { ref: "header", staticClass: "c-table__header" },
                _vm._l(_vm.levels, function (i) {
                  return _c(
                    "tr",
                    { key: i, staticClass: "c-table__header-row" },
                    [
                      _vm.withMassOperations
                        ? _c(
                            "th",
                            {
                              staticClass: "c-table__column",
                              attrs: { colspan: "1", rowspan: "1" },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "c-table__column-wrapper" },
                                [
                                  _c("c-switcher", {
                                    staticClass: "c-table__checkbox",
                                    attrs: { type: "checkbox" },
                                    on: { input: _vm.onCheckboxAllChanged },
                                    model: {
                                      value: _vm.checkboxAll,
                                      callback: function ($$v) {
                                        _vm.checkboxAll = $$v
                                      },
                                      expression: "checkboxAll",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._l(_vm.getTableColumns(i), function (column) {
                        return _c(
                          "th",
                          {
                            key: column.id,
                            staticClass: "c-table__column",
                            class: {
                              "c-table__column_with_filter": column.type,
                              "c-table__column_hidden": _vm.isDisabled(
                                column.id
                              ),
                              "c-table__column_sorted": _vm.isSorted(column),
                            },
                            style: { width: column.width ? column.width : "" },
                            attrs: {
                              id: `c-table-column-${column.id}`,
                              colspan:
                                column.colspan === undefined
                                  ? _vm.getColspan(column)
                                  : column.colspan,
                              rowspan: _vm.getRowspan(column),
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "c-table__column-wrapper" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "c-table__column-label",
                                    class: {
                                      "c-table__column-label-children":
                                        !_vm.isCategory(column) &&
                                        _vm.sortedColumn &&
                                        !(
                                          _vm.data.type === "discipline" &&
                                          column.id === "explanatory"
                                        ),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.setSortedColumn(
                                          column,
                                          _vm.sortedColumn
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(column.fullName) + " ")]
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      _vm.data.actions && i === 1
                        ? _c(
                            "th",
                            {
                              staticClass:
                                "c-table__column c-table__column_actions",
                              attrs: {
                                id: "c-table-actions-element",
                                rowspan: _vm.levels,
                              },
                            },
                            [
                              _c("div", {
                                staticClass: "c-table__column-empty",
                              }),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  )
                }),
                0
              ),
              !_vm.data.isGroupByCategory
                ? _c(
                    "tbody",
                    { staticClass: "c-table__records" },
                    _vm._l(_vm.sortedRecords, function (record, recordIndex) {
                      return _c(
                        "tr",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: record.isShowRow,
                              expression: "record.isShowRow",
                            },
                          ],
                          key: recordIndex,
                          staticClass: "c-table__record",
                          class: {
                            "c-table__record__red":
                              (_vm.data.type === "discipline" &&
                                (record.explanatory.value === "available" ||
                                  record.explanatory.value === "expired" ||
                                  record.isFined.toString() === "1")) ||
                              (_vm.data.type === "inventory-items-positions" &&
                                record.status.desc === "issuedoverdue"),
                            "c-table__record__yellow":
                              _vm.data.type === "inventory-items-positions" &&
                              record.status.desc === "notissued",
                          },
                        },
                        [
                          _vm.withMassOperations
                            ? _c(
                                "td",
                                {
                                  staticClass:
                                    "c-table__cell__collapse__button",
                                  class: {
                                    "c-table__cell__collapse__button__docs":
                                      _vm.data.type ===
                                        "documents-acting-documents" ||
                                      _vm.data.type === "documents-archive",
                                  },
                                  style: {
                                    "border-bottom":
                                      _vm.sortedRecords.length ===
                                      _vm.groupIndex + 1
                                        ? "solid 1px #DFE4EF !important"
                                        : "",
                                  },
                                  attrs: { colspan: "1", rowspan: "1" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "c-table__cell__collapse__button-wrapper",
                                    },
                                    [
                                      _c("c-switcher", {
                                        staticClass: "c-table__checkbox",
                                        attrs: { type: "checkbox" },
                                        on: {
                                          input: function ($event) {
                                            return _vm.onSwitcherChanged(record)
                                          },
                                        },
                                        model: {
                                          value: record.checkbox,
                                          callback: function ($$v) {
                                            _vm.$set(record, "checkbox", $$v)
                                          },
                                          expression: "record.checkbox",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._l(
                            _vm.getTableColumns(_vm.levels),
                            function (column, cellIndex) {
                              return [
                                (record[column.id] &&
                                  record[column.id].value) ||
                                _vm.allowedType
                                  ? _c(
                                      "td",
                                      {
                                        key: `cellIndex-${cellIndex}`,
                                        staticClass: "c-table__cell",
                                        class: {
                                          "c-table__cell_string":
                                            column.type === "string",
                                          "c-table__cell_reference":
                                            column.type === "reference",
                                          "c-table__cell_number":
                                            column.type === "number",
                                          "c-table__cell_date":
                                            column.type === "date",
                                          "c-table__cell_hidden":
                                            _vm.isDisabled(column.id),
                                          ["c-table__cell_" + column.id]:
                                            column.id,
                                        },
                                      },
                                      [
                                        column.id === "amount" &&
                                        _vm.data.type === "finance"
                                          ? _c("c-table-finance-event-cell", {
                                              attrs: {
                                                "cell-value":
                                                  record[column.id].value,
                                              },
                                            })
                                          : column.id === "balance" &&
                                            _vm.data.type === "finance"
                                          ? _c("c-table-finance-deposit-cell", {
                                              attrs: {
                                                "deposit-amount-max":
                                                  record.depositAmountMax,
                                                "cell-value": record[column.id]
                                                  .value
                                                  ? record[column.id].value
                                                  : "0",
                                              },
                                            })
                                          : _vm.data.type === "discipline" &&
                                            column.id === "explanatory"
                                          ? _c(
                                              "c-table-discipline-explanatory-cell",
                                              {
                                                attrs: {
                                                  record: record,
                                                  "cell-value":
                                                    record[column.id].value,
                                                },
                                              }
                                            )
                                          : _vm.data.type === "discipline" &&
                                            column.id === "summ"
                                          ? _c(
                                              "c-table-discipline-amount-cell",
                                              { attrs: { record: record } }
                                            )
                                          : _vm.data.type === "discipline" &&
                                            column.id === "reason"
                                          ? _c(
                                              "c-table-with-description-cell",
                                              {
                                                attrs: {
                                                  value: record.reason.value,
                                                  "description-model":
                                                    record.reason
                                                      .descriptionModel,
                                                },
                                                on: {
                                                  showDescription:
                                                    _vm.showDescription,
                                                },
                                              }
                                            )
                                          : _vm.data.type ===
                                              "referrals-history-bonuses" &&
                                            column.id === "accruedWrittenOff"
                                          ? _c(
                                              "c-table-referrals-accured-written-off-cell",
                                              {
                                                attrs: {
                                                  "cell-value":
                                                    record[column.id].value,
                                                },
                                              }
                                            )
                                          : _vm.isReferralType &&
                                            column.id === "name"
                                          ? _c(
                                              "c-table-referrals-link-to-brought-employee",
                                              {
                                                attrs: {
                                                  record: record,
                                                  "cell-value":
                                                    record[column.id].value,
                                                },
                                              }
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "c-table__cell-value",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    record[column.id].value
                                                  ),
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      record[column.id].value
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._l(
                                  record[column.id].values,
                                  function (rec) {
                                    return _c(
                                      "td",
                                      {
                                        key: `c-table-cell-${rec.value}`,
                                        staticClass: "c-table__cell",
                                        class: {
                                          "c-table__cell_string":
                                            column.type === "string",
                                          "c-table__cell_reference":
                                            column.type === "reference",
                                          "c-table__cell_number":
                                            column.type === "number",
                                          "c-table__cell_date":
                                            column.type === "date",
                                          "c-table__cell_hidden":
                                            _vm.isDisabled(column.id),
                                          "c-table__cell_vertical_align":
                                            _vm.data.type === "main-factors" &&
                                            record[column.id].values[0]
                                              .countIntervals,
                                          ["c-table__cell_" + column.id]:
                                            column.id,
                                        },
                                        attrs: { rowspan: rec.rowspan },
                                      },
                                      [
                                        record[column.id] &&
                                        record[column.id].values &&
                                        rec.value
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "c-table__cell-values",
                                                domProps: {
                                                  innerHTML: _vm._s(rec.value),
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(rec.value) + " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  }
                                ),
                              ]
                            }
                          ),
                          _vm.data.actions
                            ? _c(
                                "td",
                                {
                                  staticClass:
                                    "c-table__cell c-table__cell_actions",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "c-table__cell-actions" },
                                    [
                                      _vm.data.type === "main-factors"
                                        ? _c("c-table-main-factors-actions", {
                                            attrs: { record: record },
                                          })
                                        : _vm._e(),
                                      _vm.data.type === "finance"
                                        ? _c("c-table-finance-actions", {
                                            attrs: { record: record },
                                          })
                                        : _vm._e(),
                                      _vm.data.type ===
                                      "inventory-items-positions"
                                        ? _c(
                                            "c-table-inventory-items-actions",
                                            { attrs: { record: record } }
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        2
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._l(_vm.sortedRecords, function (group, groupIndex) {
                return _c(
                  "tbody",
                  {
                    key: `record-${groupIndex}`,
                    staticClass: "c-table__records",
                  },
                  [
                    _vm.data.isGroupByCategory
                      ? [
                          _c(
                            "tr",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle",
                                  value: `category-collapse-${_vm.id}-${groupIndex}`,
                                  expression:
                                    "`category-collapse-${id}-${groupIndex}`",
                                },
                              ],
                              staticClass: "c-table__record",
                            },
                            [
                              _vm.withMassOperations
                                ? _c(
                                    "th",
                                    {
                                      staticClass:
                                        "c-table__cell__collapse__button",
                                      class: {
                                        "c-table__cell__collapse__button__docs":
                                          _vm.data.type ===
                                            "documents-acting-documents" ||
                                          _vm.data.type === "documents-archive",
                                      },
                                      style: {
                                        "border-bottom":
                                          _vm.sortedRecords.length ===
                                          groupIndex + 1
                                            ? "solid 1px #DFE4EF !important"
                                            : "",
                                      },
                                      attrs: { colspan: "1", rowspan: "1" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "c-table__cell__collapse__button-wrapper",
                                        },
                                        [
                                          _c("c-switcher", {
                                            staticClass: "c-table__checkbox",
                                            attrs: { type: "checkbox" },
                                            on: {
                                              input: function ($event) {
                                                return _vm.onSwitcherChanged(
                                                  group
                                                )
                                              },
                                            },
                                            model: {
                                              value: group.checkbox,
                                              callback: function ($$v) {
                                                _vm.$set(group, "checkbox", $$v)
                                              },
                                              expression: "group.checkbox",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "th",
                                {
                                  staticClass:
                                    "c-table__cell__collapse__button",
                                  class: {
                                    "c-table__cell__collapse__button__docs":
                                      _vm.data.type ===
                                        "documents-acting-documents" ||
                                      _vm.data.type === "documents-archive",
                                  },
                                  style: {
                                    "border-bottom":
                                      _vm.sortedRecords.length ===
                                      groupIndex + 1
                                        ? "solid 1px #DFE4EF !important"
                                        : "",
                                  },
                                  attrs: {
                                    colspan:
                                      _vm.getTableColumns(_vm.levels).length +
                                      (_vm.data.actions ? 1 : 0),
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "c-table__cell__collapse__button-wrapper",
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          staticClass:
                                            "c-table__cell__collapse__button__icon",
                                          attrs: {
                                            width: "22",
                                            height: "22",
                                            viewBox: "0 0 22 22",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                          },
                                        },
                                        [
                                          _c("circle", {
                                            attrs: {
                                              cx: "11",
                                              cy: "11",
                                              r: "10.5",
                                              fill: "white",
                                              stroke: "#DFE4EF",
                                            },
                                          }),
                                          _c("path", {
                                            attrs: {
                                              d: "M10.5398 13.4727C10.2813 13.2141 10.2813 12.7948 10.5398 12.5361L13.87 9.20431C14.1285 8.94569 14.5476 8.94569 14.8061 9.20432C15.0646 9.46294 15.0646 9.88225 14.8061 10.1409L11.4759 13.4727C11.2174 13.7313 10.7983 13.7313 10.5398 13.4727Z",
                                              fill: "#0066FF",
                                            },
                                          }),
                                          _c("path", {
                                            attrs: {
                                              d: "M11.4706 13.4727C11.7291 13.2141 11.7291 12.7948 11.4706 12.5361L8.12999 9.19397C7.87149 8.93534 7.45238 8.93534 7.19388 9.19397C6.93537 9.45259 6.93537 9.8719 7.19388 10.1305L10.5345 13.4727C10.793 13.7313 11.2121 13.7313 11.4706 13.4727Z",
                                              fill: "#0066FF",
                                            },
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "c-table__cell__collapse__button__category__name",
                                        },
                                        [_vm._v(_vm._s(group.categoryName))]
                                      ),
                                      _vm.data.type ===
                                        "documents-acting-documents" ||
                                      _vm.data.type === "documents-archive"
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "c-table__cell__collapse__button__category__count",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(group.records.length) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.data.type ===
                                        "inventory-items-positions" &&
                                      group.notIssuedPositionsTooltip.length > 0
                                        ? _c("c-button-2", {
                                            directives: [
                                              {
                                                name: "b-popover",
                                                rawName: "v-b-popover.html",
                                                value: {
                                                  container: "#app",
                                                  trigger: "hover blur",
                                                  content:
                                                    group.notIssuedPositionsTooltip,
                                                  placement: "top",
                                                },
                                                expression:
                                                  "{\n                    container: '#app',\n                    trigger: 'hover blur',\n                    content: group.notIssuedPositionsTooltip,\n                    placement: 'top',\n                  }",
                                                modifiers: { html: true },
                                              },
                                            ],
                                            staticClass:
                                              "c-table__cell__collapse__button__button",
                                            attrs: {
                                              icon: "time-is-out",
                                              size: "iconic",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.data.type ===
                                        "inventory-items-positions" &&
                                      group.overduePositionsTooltip.length > 0
                                        ? _c("c-button-2", {
                                            directives: [
                                              {
                                                name: "b-popover",
                                                rawName: "v-b-popover.html",
                                                value: {
                                                  container: "#app",
                                                  trigger: "hover blur",
                                                  content:
                                                    group.overduePositionsTooltip,
                                                  placement: "top",
                                                },
                                                expression:
                                                  "{\n                    container: '#app',\n                    trigger: 'hover blur',\n                    content: group.overduePositionsTooltip,\n                    placement: 'top',\n                  }",
                                                modifiers: { html: true },
                                              },
                                            ],
                                            staticClass:
                                              "c-table__cell__collapse__button__button",
                                            attrs: {
                                              icon: "need",
                                              size: "iconic",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.data.type ===
                                        "documents-acting-documents" &&
                                      group.isHaveDocumentsExpired
                                        ? _c("c-button-2", {
                                            directives: [
                                              {
                                                name: "b-popover",
                                                rawName: "v-b-popover.html",
                                                value: {
                                                  id: "personalEmployeeDocumentsPopover",
                                                  container: "#app",
                                                  trigger: "hover click",
                                                  content:
                                                    "Категория содержит документы, у которых истек срок годности",
                                                  placement: "top",
                                                },
                                                expression:
                                                  "{\n                    id: 'personalEmployeeDocumentsPopover',\n                    container: '#app',\n                    trigger: 'hover click',\n                    content: 'Категория содержит документы, у которых истек срок годности',\n                    placement: 'top',\n                  }",
                                                modifiers: { html: true },
                                              },
                                            ],
                                            staticClass:
                                              "c-table__cell__collapse__button__button",
                                            attrs: {
                                              icon: "time-is-out",
                                              size: "iconic",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.data.type ===
                                        "documents-acting-documents" &&
                                      group.isHaveExpirationDate
                                        ? _c("c-button-2", {
                                            directives: [
                                              {
                                                name: "b-popover",
                                                rawName: "v-b-popover.html",
                                                value: {
                                                  id: "personalEmployeeDocumentsPopover",
                                                  container: "#app",
                                                  trigger: "hover blur",
                                                  content:
                                                    "Категория содержит документы, у которых истекает срок годности",
                                                  placement: "top",
                                                },
                                                expression:
                                                  "{\n                    id: 'personalEmployeeDocumentsPopover',\n                    container: '#app',\n                    trigger: 'hover blur',\n                    content: 'Категория содержит документы, у которых истекает срок годности',\n                    placement: 'top',\n                  }",
                                                modifiers: { html: true },
                                              },
                                            ],
                                            staticClass:
                                              "c-table__cell__collapse__button__button",
                                            attrs: {
                                              icon: "expiration-date",
                                              size: "iconic",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c("div", {
                                    staticClass:
                                      "c-table__cell__collapse__button__border__right",
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._l(group.records, function (record, recordIndex) {
                            return _c(
                              "b-collapse",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: record.isShowRow,
                                    expression: "record.isShowRow",
                                  },
                                ],
                                key: recordIndex,
                                staticClass: "c-table__record",
                                class: {
                                  "c-table__record__yellow":
                                    (_vm.data.type ===
                                      "inventory-items-positions" &&
                                      record.status.desc === "notissued") ||
                                    (_vm.data.type ===
                                      "documents-acting-documents" &&
                                      record.expireSoon),
                                  "c-table__record__red":
                                    (_vm.data.type ===
                                      "inventory-items-positions" &&
                                      record.status.desc === "issuedoverdue") ||
                                    (_vm.data.type ===
                                      "documents-acting-documents" &&
                                      record.expired),
                                },
                                attrs: {
                                  id: `category-collapse-${_vm.id}-${groupIndex}`,
                                  tag: "tr",
                                  visible: "",
                                },
                              },
                              [
                                record.isShowRow
                                  ? [
                                      _vm.data.type !== "move-in-company"
                                        ? _c(
                                            "td",
                                            { staticClass: "c-table__cell" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "c-table__cell-value",
                                                },
                                                [
                                                  _c("c-switcher", {
                                                    staticClass:
                                                      "c-table__checkbox",
                                                    attrs: { type: "checkbox" },
                                                    on: {
                                                      input: function ($event) {
                                                        return _vm.onSwitcherChanged(
                                                          record
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value: record.checkbox,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          record,
                                                          "checkbox",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "record.checkbox",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._l(
                                        _vm.getTableColumns(_vm.levels),
                                        function (column) {
                                          return _c(
                                            "td",
                                            {
                                              key: column.id,
                                              staticClass: "c-table__cell",
                                              class: {
                                                "c-table__cell_string":
                                                  column.type === "string",
                                                "c-table__cell_reference":
                                                  column.type === "reference",
                                                "c-table__cell_number":
                                                  column.type === "number",
                                                "c-table__cell_date":
                                                  column.type === "date",
                                                "c-table__cell_hidden":
                                                  _vm.isDisabled(column.id),
                                                ["c-table__cell_" + column.id]:
                                                  column.id,
                                              },
                                            },
                                            [
                                              column.id === "files" &&
                                              _vm.isDocumentType
                                                ? _c(
                                                    "c-table-documents-files-cell",
                                                    {
                                                      attrs: {
                                                        record: record,
                                                        "cell-value":
                                                          record[column.id]
                                                            .value,
                                                      },
                                                    }
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "c-table__cell-value",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          record[column.id]
                                                            .value
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            record[column.id]
                                                              .value
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      _vm.data.actions
                                        ? _c(
                                            "td",
                                            {
                                              staticClass:
                                                "c-table__cell c-table__cell_actions",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "c-table__cell-actions",
                                                },
                                                [
                                                  _vm.data.type ===
                                                  "inventory-items-positions"
                                                    ? _c(
                                                        "c-table-inventory-items-actions",
                                                        {
                                                          attrs: {
                                                            record: record,
                                                          },
                                                        }
                                                      )
                                                    : _vm._e(),
                                                  _vm.data.type ===
                                                    "documents-acting-documents" ||
                                                  _vm.data.type ===
                                                    "documents-archive"
                                                    ? _c(
                                                        "c-table-documents-actions",
                                                        {
                                                          attrs: {
                                                            record: record,
                                                            "record-id": `${groupIndex}-${recordIndex}`,
                                                            "table-type":
                                                              _vm.data.type,
                                                          },
                                                          on: {
                                                            changeArchiveStatusSingle:
                                                              _vm.changeArchiveStatusSingle,
                                                          },
                                                        }
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            )
                          }),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              }),
            ],
            2
          ),
        ]
      ),
      _vm.data.records.length === 0
        ? _c("div", { staticClass: "c-table__empty__records" }, [
            _vm._v(_vm._s(_vm.emptyRecordsLabel)),
          ])
        : _vm._e(),
      !_vm.data.isGroupByCategory && _vm.data.records.length > 0
        ? _c(
            "div",
            { staticClass: "c-table__container__mobile" },
            [
              _c(
                "div",
                {
                  staticClass: "c-table__container__mobile__fixed__th",
                  attrs: { id: "tableMobileFixed" + _vm.id },
                },
                [
                  _c(
                    "table",
                    { ref: "container" },
                    [
                      _vm._l(
                        _vm.getColumns(_vm.data.levels),
                        function (column) {
                          return [
                            column.colspan === 1
                              ? _c(
                                  "tr",
                                  {
                                    key: `column-${column.id}`,
                                    staticClass: "c-table__record",
                                  },
                                  [
                                    _c(
                                      "th",
                                      {
                                        staticClass:
                                          "c-table__column c-table__column__mobile",
                                        class: {
                                          "c-table__column_sorted":
                                            _vm.isSorted(column) &&
                                            !(
                                              _vm.data.type === "discipline" &&
                                              column.id === "explanatory"
                                            ),
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "c-table__column-wrapper c-table__column-wrapper-mobile",
                                            class: {
                                              "c-table__column-wrapper-mobile-main-factors":
                                                _vm.data.type ===
                                                "main-factors",
                                              "c-table__column-wrapper-mobile-finance":
                                                _vm.data.type === "finance",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setSortedColumn(
                                                  column,
                                                  _vm.sortedColumn
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "c-table__column-label",
                                                class: `c-table__column-label-${column.id}`,
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(column.label) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._l(
                                      _vm.sortedRecords,
                                      function (record, recordIndex) {
                                        return [
                                          record[column.id].value ||
                                          _vm.isFinanceDepositReferralCell
                                            ? _c(
                                                "td",
                                                {
                                                  key: recordIndex,
                                                  staticClass: "c-table__cell",
                                                  class: {
                                                    "c-table__cell__border__none":
                                                      _vm.sortedRecords.length -
                                                        1 ===
                                                      recordIndex,
                                                    "c-table__cell__move__in__company":
                                                      _vm.data.type ===
                                                      "move-in-company",
                                                  },
                                                },
                                                [
                                                  column.id === "amount" &&
                                                  _vm.data.type === "finance"
                                                    ? _c(
                                                        "c-table-finance-event-cell",
                                                        {
                                                          attrs: {
                                                            "cell-value":
                                                              record[column.id]
                                                                .value,
                                                          },
                                                        }
                                                      )
                                                    : column.id === "balance" &&
                                                      _vm.data.type ===
                                                        "finance"
                                                    ? _c(
                                                        "c-table-finance-deposit-cell",
                                                        {
                                                          attrs: {
                                                            "deposit-amount-max":
                                                              record.depositAmountMax,
                                                            "cell-value":
                                                              record[column.id]
                                                                .value,
                                                          },
                                                        }
                                                      )
                                                    : _vm.data.type ===
                                                        "discipline" &&
                                                      column.id ===
                                                        "explanatory"
                                                    ? _c(
                                                        "c-table-discipline-explanatory-cell",
                                                        {
                                                          attrs: {
                                                            record: record,
                                                            "cell-value":
                                                              record[column.id]
                                                                .value,
                                                          },
                                                        }
                                                      )
                                                    : _vm.data.type ===
                                                        "discipline" &&
                                                      column.id === "summ"
                                                    ? _c(
                                                        "c-table-discipline-amount-cell",
                                                        {
                                                          attrs: {
                                                            record: record,
                                                          },
                                                        }
                                                      )
                                                    : _vm.data.type ===
                                                        "discipline" &&
                                                      column.id === "reason"
                                                    ? _c(
                                                        "c-table-with-description-cell",
                                                        {
                                                          attrs: {
                                                            value:
                                                              record.reason
                                                                .value,
                                                            model:
                                                              record.reason
                                                                .model,
                                                          },
                                                          on: {
                                                            showDescription:
                                                              _vm.showDescription,
                                                          },
                                                        }
                                                      )
                                                    : _vm.data.type ===
                                                        "referrals-history-bonuses" &&
                                                      column.id ===
                                                        "accruedWrittenOff"
                                                    ? _c(
                                                        "c-table-referrals-accured-written-off-cell",
                                                        {
                                                          attrs: {
                                                            "cell-value":
                                                              record[column.id]
                                                                .value,
                                                          },
                                                        }
                                                      )
                                                    : _vm.isReferralType &&
                                                      column.id === "name"
                                                    ? _c(
                                                        "c-table-referrals-link-to-brought-employee",
                                                        {
                                                          attrs: {
                                                            record: record,
                                                            "cell-value":
                                                              record[column.id]
                                                                .value,
                                                          },
                                                        }
                                                      )
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "c-table__cell-value",
                                                          class: {
                                                            "c-table__cell-value-nowrap":
                                                              _vm.data.type ===
                                                              "main-factors",
                                                          },
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              record[column.id]
                                                                .value
                                                            ),
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                record[
                                                                  column.id
                                                                ].value
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._l(column.colspan, function (row, ind) {
                              return _c(
                                "tr",
                                {
                                  key: `record-s-${column.id}-${ind}`,
                                  staticClass: "c-table__record",
                                },
                                [
                                  column.colspan > 1
                                    ? [
                                        ind === 0
                                          ? _c(
                                              "th",
                                              {
                                                staticClass:
                                                  "c-table__column c-table__column__mobile",
                                                attrs: {
                                                  rowspan: column.colspan,
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "c-table__column-wrapper c-table__column-wrapper-mobile",
                                                    class: {
                                                      "c-table__column-wrapper-mobile-main-factors":
                                                        _vm.data.type ===
                                                        "main-factors",
                                                      "c-table__column-wrapper-mobile-finance":
                                                        _vm.data.type ===
                                                        "finance",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "c-table__column-label",
                                                        class: `c-table__column-label-${column.id}`,
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              column.label
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._l(
                                          _vm.sortedRecords,
                                          function (record, recordIndex) {
                                            return [
                                              record[column.id].values[row - 1]
                                                .value
                                                ? _c(
                                                    "td",
                                                    {
                                                      key: `column-r-${recordIndex}`,
                                                      staticClass:
                                                        "c-table__cell",
                                                      class: {
                                                        "c-table__cell__border__none":
                                                          _vm.sortedRecords
                                                            .length -
                                                            1 ===
                                                          recordIndex,
                                                        "c-table__cell__move__in__company":
                                                          _vm.data.type ===
                                                          "move-in-company",
                                                      },
                                                      attrs: {
                                                        colspan:
                                                          record[column.id]
                                                            .values[row - 1]
                                                            .rowspan,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "c-table__cell-values",
                                                          class: {
                                                            "c-table__cell-value-nowrap":
                                                              _vm.data.type ===
                                                              "main-factors",
                                                          },
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              record[column.id]
                                                                .values[row - 1]
                                                                .value
                                                            ),
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                record[
                                                                  column.id
                                                                ].values[
                                                                  row - 1
                                                                ].value
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          }
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            }),
                          ]
                        }
                      ),
                      _vm.data.actions
                        ? _c(
                            "tr",
                            {
                              staticClass: "c-table__record",
                              style: {
                                height:
                                  _vm.data.type === "main-factors"
                                    ? "34px"
                                    : "",
                              },
                            },
                            [
                              _c(
                                "th",
                                {
                                  staticClass: "c-table__column",
                                  attrs: { rowspan: _vm.levels },
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "c-table__column-empty c-table__column-empty-mobile",
                                  }),
                                ]
                              ),
                              _vm._l(
                                _vm.sortedRecords,
                                function (record, recordIndex) {
                                  return _c(
                                    "td",
                                    {
                                      key: `record-mobile-${recordIndex}`,
                                      staticClass: "c-table__cell",
                                      class: {
                                        "c-table__cell__border__none":
                                          _vm.sortedRecords.length - 1 ===
                                          recordIndex,
                                      },
                                    },
                                    [
                                      _vm.data.type === "main-factors"
                                        ? _c("c-table-main-factors-actions", {
                                            attrs: { record: record },
                                          })
                                        : _vm._e(),
                                      _vm.data.type === "finance"
                                        ? _c("c-table-finance-actions", {
                                            attrs: { record: record },
                                          })
                                        : _vm._e(),
                                      _vm.data.type ===
                                      "inventory-items-positions"
                                        ? _c(
                                            "c-table-inventory-items-actions",
                                            { attrs: { record: record } }
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
              _c(
                "perfect-scrollbar",
                {
                  staticClass: "c-table__container__mobile__scrolled__td",
                  attrs: {
                    id: "tableMobileScroll" + _vm.id,
                    options: {
                      useBothWheelAxes: false,
                      suppressScrollX: false,
                      suppressScrollY: true,
                    },
                    tag: "div",
                  },
                  on: {
                    scroll: function ($event) {
                      return _vm.setShadowTableMobile(_vm.id)
                    },
                  },
                },
                [
                  _c(
                    "table",
                    { ref: "container" },
                    [
                      _vm._l(
                        _vm.getColumns(_vm.data.levels),
                        function (column, recordIndex) {
                          return [
                            column.colspan === 1
                              ? _c(
                                  "tr",
                                  {
                                    key: `${recordIndex}-key-column`,
                                    staticClass: "c-table__record",
                                  },
                                  [
                                    _c(
                                      "th",
                                      {
                                        staticClass:
                                          "c-table__column c-table__column__mobile",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "c-table__column-wrapper c-table__column-wrapper-mobile",
                                            class: {
                                              "c-table__column-wrapper-mobile-main-factors":
                                                _vm.data.type ===
                                                "main-factors",
                                              "c-table__column-wrapper-mobile-finance":
                                                _vm.data.type === "finance",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "c-table__column-label",
                                                class: `c-table__column-label-${column.id}`,
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(column.label) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._l(
                                      _vm.sortedRecords,
                                      function (record, recordIndex) {
                                        return [
                                          record[column.id].value ||
                                          _vm.allowedType
                                            ? _c(
                                                "td",
                                                {
                                                  key: recordIndex,
                                                  staticClass: "c-table__cell",
                                                  class: {
                                                    "c-table__cell__move__in__company":
                                                      _vm.data.type ===
                                                      "move-in-company",
                                                    "c-table__cell__red":
                                                      _vm.data.type ===
                                                        "inventory-items-positions" &&
                                                      (column.id === "status" ||
                                                        column.id ===
                                                          "shelfLife") &&
                                                      record.status.desc ===
                                                        "issuedoverdue",
                                                    "c-table__cell__yellow":
                                                      _vm.data.type ===
                                                        "inventory-items-positions" &&
                                                      (column.id === "status" ||
                                                        column.id ===
                                                          "shelfLife") &&
                                                      record.status.desc ===
                                                        "notissued",
                                                  },
                                                },
                                                [
                                                  column.id === "amount" &&
                                                  _vm.data.type === "finance"
                                                    ? _c(
                                                        "c-table-finance-event-cell",
                                                        {
                                                          attrs: {
                                                            "cell-value":
                                                              record[column.id]
                                                                .value,
                                                          },
                                                        }
                                                      )
                                                    : column.id === "balance" &&
                                                      _vm.data.type ===
                                                        "finance"
                                                    ? _c(
                                                        "c-table-finance-deposit-cell",
                                                        {
                                                          attrs: {
                                                            "deposit-amount-max":
                                                              record.depositAmountMax,
                                                            "cell-value":
                                                              record[column.id]
                                                                .value,
                                                          },
                                                        }
                                                      )
                                                    : _vm.data.type ===
                                                        "discipline" &&
                                                      column.id ===
                                                        "explanatory"
                                                    ? _c(
                                                        "c-table-discipline-explanatory-cell",
                                                        {
                                                          attrs: {
                                                            record: record,
                                                            "cell-value":
                                                              record[column.id]
                                                                .value,
                                                          },
                                                        }
                                                      )
                                                    : _vm.data.type ===
                                                        "discipline" &&
                                                      column.id === "summ"
                                                    ? _c(
                                                        "c-table-discipline-amount-cell",
                                                        {
                                                          attrs: {
                                                            record: record,
                                                          },
                                                        }
                                                      )
                                                    : _vm.data.type ===
                                                        "discipline" &&
                                                      column.id === "reason"
                                                    ? _c(
                                                        "c-table-with-description-cell",
                                                        {
                                                          attrs: {
                                                            value:
                                                              record.reason
                                                                .value,
                                                            model:
                                                              record.reason
                                                                .model,
                                                          },
                                                          on: {
                                                            showDescription:
                                                              _vm.showDescription,
                                                          },
                                                        }
                                                      )
                                                    : _vm.data.type ===
                                                        "referrals-history-bonuses" &&
                                                      column.id ===
                                                        "accruedWrittenOff"
                                                    ? _c(
                                                        "c-table-referrals-accured-written-off-cell",
                                                        {
                                                          attrs: {
                                                            "cell-value":
                                                              record[column.id]
                                                                .value,
                                                          },
                                                        }
                                                      )
                                                    : _vm.isReferralType &&
                                                      column.id === "name"
                                                    ? _c(
                                                        "c-table-referrals-link-to-brought-employee",
                                                        {
                                                          attrs: {
                                                            record: record,
                                                            "cell-value":
                                                              record[column.id]
                                                                .value,
                                                          },
                                                        }
                                                      )
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "c-table__cell-value",
                                                          class: {
                                                            "c-table__cell-value-nowrap":
                                                              _vm.data.type ===
                                                              "main-factors",
                                                          },
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              record[column.id]
                                                                .value
                                                            ),
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                record[
                                                                  column.id
                                                                ].value
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._l(column.colspan, function (row, ind) {
                              return _c(
                                "tr",
                                {
                                  key: `column-${column.id}-${ind}-x`,
                                  staticClass: "c-table__record",
                                },
                                [
                                  column.colspan > 1
                                    ? [
                                        ind === 0
                                          ? _c(
                                              "th",
                                              {
                                                staticClass:
                                                  "c-table__column c-table__column__mobile",
                                                attrs: {
                                                  rowspan: column.colspan,
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "c-table__column-wrapper",
                                                    class: {
                                                      "c-table__column-wrapper-mobile-main-factors":
                                                        _vm.data.type ===
                                                        "main-factors",
                                                      "c-table__column-wrapper-mobile-finance":
                                                        _vm.data.type ===
                                                        "finance",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "c-table__column-label",
                                                        class: `c-table__column-label-${column.id}`,
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              column.label
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._l(
                                          _vm.sortedRecords,
                                          function (record, recordIndex) {
                                            return [
                                              record[column.id].values[row - 1]
                                                .value
                                                ? _c(
                                                    "td",
                                                    {
                                                      key: `${recordIndex}-record`,
                                                      staticClass:
                                                        "c-table__cell",
                                                      attrs: {
                                                        colspan:
                                                          record[column.id]
                                                            .values[row - 1]
                                                            .rowspan,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "c-table__cell-values",
                                                          class: {
                                                            "c-table__cell-value-nowrap":
                                                              _vm.data.type ===
                                                              "main-factors",
                                                          },
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              record[column.id]
                                                                .values[row - 1]
                                                                .value
                                                            ),
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                record[
                                                                  column.id
                                                                ].values[
                                                                  row - 1
                                                                ].value
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          }
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            }),
                          ]
                        }
                      ),
                      _vm.data.actions
                        ? _c(
                            "tr",
                            {
                              staticClass: "c-table__record",
                              style: {
                                height:
                                  _vm.data.type === "main-factors"
                                    ? "34px"
                                    : "",
                              },
                            },
                            [
                              _c(
                                "th",
                                {
                                  staticClass: "c-table__column",
                                  attrs: { rowspan: _vm.levels },
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "c-table__column-empty c-table__column-empty-mobile",
                                  }),
                                ]
                              ),
                              _vm._l(
                                _vm.sortedRecords,
                                function (record, recordIndex) {
                                  return _c(
                                    "td",
                                    {
                                      key: `actions-cell-${recordIndex}`,
                                      staticClass: "c-table__cell",
                                    },
                                    [
                                      _vm.data.type === "main-factors"
                                        ? _c("c-table-main-factors-actions", {
                                            attrs: { record: record },
                                          })
                                        : _vm._e(),
                                      _vm.data.type === "finance"
                                        ? _c("c-table-finance-actions", {
                                            attrs: { record: record },
                                          })
                                        : _vm._e(),
                                      _vm.data.type ===
                                      "inventory-items-positions"
                                        ? _c(
                                            "c-table-inventory-items-actions",
                                            { attrs: { record: record } }
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.data.isGroupByCategory && _vm.data.records.length > 0
        ? _c(
            "div",
            { ref: "container", staticClass: "c-table__container__mobile" },
            _vm._l(_vm.sortedRecords, function (group, groupIndex) {
              return _c(
                "div",
                { key: `${groupIndex}-record` },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle",
                          value: `category-collapse-${_vm.id}${groupIndex}`,
                          expression: "`category-collapse-${id}${groupIndex}`",
                        },
                      ],
                      staticClass:
                        "c-table__cell__collapse__button d-flex align-items-center shadow-none",
                      class: {
                        "c-table__cell__collapse__button__hide__borders":
                          groupIndex === 0,
                        "c-table__cell__collapse__button__hide__borders__last":
                          _vm.sortedRecords.length === groupIndex + 1,
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "c-table__cell__collapse__button-wrapper",
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass:
                                "c-table__cell__collapse__button__icon",
                              attrs: {
                                width: "22",
                                height: "22",
                                viewBox: "0 0 22 22",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("circle", {
                                attrs: {
                                  cx: "11",
                                  cy: "11",
                                  r: "10.5",
                                  fill: "white",
                                  stroke: "#D3D8DF",
                                },
                              }),
                              _c("path", {
                                attrs: {
                                  d: "M10.5398 13.4727C10.2813 13.2141 10.2813 12.7948 10.5398 12.5361L13.87 9.20431C14.1285 8.94569 14.5476 8.94569 14.8061 9.20432C15.0646 9.46294 15.0646 9.88225 14.8061 10.1409L11.4759 13.4727C11.2174 13.7313 10.7983 13.7313 10.5398 13.4727Z",
                                  fill: "#0066FF",
                                },
                              }),
                              _c("path", {
                                attrs: {
                                  d: "M11.4706 13.4727C11.7291 13.2141 11.7291 12.7948 11.4706 12.5361L8.12999 9.19397C7.87149 8.93534 7.45238 8.93534 7.19388 9.19397C6.93537 9.45259 6.93537 9.8719 7.19388 10.1305L10.5345 13.4727C10.793 13.7313 11.2121 13.7313 11.4706 13.4727Z",
                                  fill: "#0066FF",
                                },
                              }),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass:
                                "c-table__cell__collapse__button__category__name",
                            },
                            [_vm._v(_vm._s(group.categoryName))]
                          ),
                          _vm.data.type === "documents-acting-documents" ||
                          _vm.data.type === "documents-archive"
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "c-table__cell__collapse__button__category__count",
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(group.records.length) + " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.data.type === "inventory-items-positions" &&
                          group.notIssuedPositionsTooltip.length > 0
                            ? _c("c-button-2", {
                                directives: [
                                  {
                                    name: "b-toggle",
                                    rawName: "v-b-toggle",
                                    value: `category-collapse-${_vm.id}${groupIndex}`,
                                    expression:
                                      "`category-collapse-${id}${groupIndex}`",
                                  },
                                  {
                                    name: "b-popover",
                                    rawName: "v-b-popover.html",
                                    value: {
                                      container: "#app",
                                      trigger: "click blur",
                                      content: group.notIssuedPositionsTooltip,
                                      placement: "top",
                                    },
                                    expression:
                                      "{\n              container: '#app',\n              trigger: 'click blur',\n              content: group.notIssuedPositionsTooltip,\n              placement: 'top',\n            }",
                                    modifiers: { html: true },
                                  },
                                ],
                                staticClass:
                                  "c-table__cell__collapse__button__button",
                                attrs: { icon: "time-is-out", size: "iconic" },
                              })
                            : _vm._e(),
                          _vm.data.type === "inventory-items-positions" &&
                          group.overduePositionsTooltip.length > 0
                            ? _c("c-button-2", {
                                directives: [
                                  {
                                    name: "b-toggle",
                                    rawName: "v-b-toggle",
                                    value: `category-collapse-${_vm.id}${groupIndex}`,
                                    expression:
                                      "`category-collapse-${id}${groupIndex}`",
                                  },
                                  {
                                    name: "b-popover",
                                    rawName: "v-b-popover.html",
                                    value: {
                                      container: "#app",
                                      trigger: "click blur",
                                      content: group.overduePositionsTooltip,
                                      placement: "top",
                                    },
                                    expression:
                                      "{\n              container: '#app',\n              trigger: 'click blur',\n              content: group.overduePositionsTooltip,\n              placement: 'top',\n            }",
                                    modifiers: { html: true },
                                  },
                                ],
                                staticClass:
                                  "c-table__cell__collapse__button__button",
                                attrs: { icon: "need", size: "iconic" },
                              })
                            : _vm._e(),
                          _vm.data.type === "documents-acting-documents" &&
                          group.isHaveDocumentsExpired
                            ? _c("c-button-2", {
                                directives: [
                                  {
                                    name: "b-toggle",
                                    rawName: "v-b-toggle",
                                    value: `category-collapse-${_vm.id}${groupIndex}`,
                                    expression:
                                      "`category-collapse-${id}${groupIndex}`",
                                  },
                                  {
                                    name: "b-popover",
                                    rawName: "v-b-popover.html",
                                    value: {
                                      id: "personalEmployeeDocumentsPopover",
                                      container: "#app",
                                      trigger: "hover blur",
                                      content:
                                        "Категория содержит документы, у которых истек срок годности",
                                      placement: "top",
                                    },
                                    expression:
                                      "{\n              id: 'personalEmployeeDocumentsPopover',\n              container: '#app',\n              trigger: 'hover blur',\n              content: 'Категория содержит документы, у которых истек срок годности',\n              placement: 'top',\n            }",
                                    modifiers: { html: true },
                                  },
                                ],
                                staticClass:
                                  "c-table__cell__collapse__button__button",
                                attrs: { icon: "time-is-out", size: "iconic" },
                              })
                            : _vm._e(),
                          _vm.data.type === "documents-acting-documents" &&
                          group.isHaveExpirationDate
                            ? _c("c-button-2", {
                                directives: [
                                  {
                                    name: "b-toggle",
                                    rawName: "v-b-toggle",
                                    value: `category-collapse-${_vm.id}${groupIndex}`,
                                    expression:
                                      "`category-collapse-${id}${groupIndex}`",
                                  },
                                  {
                                    name: "b-popover",
                                    rawName: "v-b-popover.html",
                                    value: {
                                      id: "personalEmployeeDocumentsPopover",
                                      container: "#app",
                                      trigger: "hover blur",
                                      content:
                                        "Категория содержит документы, у которых скоро истечет срок годности",
                                      placement: "top",
                                    },
                                    expression:
                                      "{\n              id: 'personalEmployeeDocumentsPopover',\n              container: '#app',\n              trigger: 'hover blur',\n              content: 'Категория содержит документы, у которых скоро истечет срок годности',\n              placement: 'top',\n            }",
                                    modifiers: { html: true },
                                  },
                                ],
                                staticClass:
                                  "c-table__cell__collapse__button__button",
                                attrs: {
                                  icon: "expiration-date",
                                  size: "iconic",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "c-table__mobile__collapse",
                      attrs: {
                        id: `category-collapse-${_vm.id}${groupIndex}`,
                        visible: "",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "c-table__container__mobile__fixed__th",
                          attrs: {
                            id: "tableMobileFixed" + _vm.id + groupIndex,
                          },
                        },
                        [
                          _c(
                            "table",
                            { ref: "container", refInFor: true },
                            [
                              _vm._l(
                                _vm.getColumns(_vm.data.levels),
                                function (column, recordIndex) {
                                  return [
                                    column.colspan === 1
                                      ? _c(
                                          "tr",
                                          {
                                            key: `mobile-record-${recordIndex}`,
                                            staticClass: "c-table__record",
                                          },
                                          [
                                            _c(
                                              "th",
                                              {
                                                staticClass:
                                                  "c-table__column c-table__column__mobile",
                                                class: {
                                                  "c-table__column_sorted":
                                                    _vm.isSorted(column),
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "c-table__column-wrapper c-table__column-wrapper-mobile",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.setSortedColumn(
                                                          column,
                                                          _vm.sortedColumn
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "c-table__column-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              column.label
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._l(
                                              _vm.sortedRecords[groupIndex]
                                                .records,
                                              function (record, recordIndex) {
                                                return [
                                                  _c(
                                                    "td",
                                                    {
                                                      key: recordIndex,
                                                      staticClass:
                                                        "c-table__cell",
                                                      class: {
                                                        "c-table__cell__move__in__company":
                                                          _vm.data.type ===
                                                          "move-in-company",
                                                      },
                                                    },
                                                    [
                                                      column.id === "event" &&
                                                      _vm.data.type ===
                                                        "finance"
                                                        ? _c(
                                                            "c-table-finance-event-cell",
                                                            {
                                                              attrs: {
                                                                "cell-value":
                                                                  record[
                                                                    column.id
                                                                  ].value,
                                                              },
                                                            }
                                                          )
                                                        : column.id ===
                                                            "balance" &&
                                                          _vm.data.type ===
                                                            "finance"
                                                        ? _c(
                                                            "c-table-finance-deposit-cell",
                                                            {
                                                              attrs: {
                                                                "cell-value":
                                                                  record[
                                                                    column.id
                                                                  ].value,
                                                              },
                                                            }
                                                          )
                                                        : _vm._e(),
                                                      column.id === "files" &&
                                                      _vm.isDocumentType
                                                        ? _c(
                                                            "c-table-documents-files-cell",
                                                            {
                                                              attrs: {
                                                                record: record,
                                                                "cell-value":
                                                                  record[
                                                                    column.id
                                                                  ].value,
                                                              },
                                                            }
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "c-table__cell-value",
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    record[
                                                                      column.id
                                                                    ].value
                                                                  ),
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    record[
                                                                      column.id
                                                                    ].value
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              }
                                            ),
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    _vm._l(column.colspan, function (row, ind) {
                                      return _c(
                                        "tr",
                                        {
                                          key: `record-m-${ind}-${column.id}`,
                                          staticClass: "c-table__record",
                                        },
                                        [
                                          column.colspan > 1
                                            ? [
                                                ind === 0
                                                  ? _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "c-table__column c-table__column__mobile",
                                                        attrs: {
                                                          rowspan:
                                                            column.colspan,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "c-table__column-wrapper",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "c-table__column-label",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      column.label
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._l(
                                                  _vm.sortedRecords[groupIndex]
                                                    .records,
                                                  function (
                                                    record,
                                                    recordIndex
                                                  ) {
                                                    return [
                                                      record[column.id].values[
                                                        row - 1
                                                      ].value
                                                        ? _c(
                                                            "td",
                                                            {
                                                              key: `group-record-${recordIndex}`,
                                                              staticClass:
                                                                "c-table__cell",
                                                              class: {
                                                                "c-table__cell__move__in__company":
                                                                  _vm.data
                                                                    .type ===
                                                                  "move-in-company",
                                                              },
                                                              attrs: {
                                                                colspan:
                                                                  record[
                                                                    column.id
                                                                  ].values[
                                                                    row - 1
                                                                  ].rowspan,
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "c-table__cell-value",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      record[
                                                                        column
                                                                          .id
                                                                      ].values[
                                                                        row - 1
                                                                      ].value
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  }
                                                ),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      )
                                    }),
                                  ]
                                }
                              ),
                              _vm.data.actions
                                ? _c(
                                    "tr",
                                    {
                                      staticClass: "c-table__record",
                                      style: {
                                        height:
                                          _vm.data.type === "main-factors"
                                            ? "34px"
                                            : "",
                                      },
                                    },
                                    [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "c-table__column",
                                          attrs: { rowspan: _vm.levels },
                                        },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "c-table__column-empty c-table__column-empty-mobile",
                                          }),
                                        ]
                                      ),
                                      _vm._l(
                                        _vm.sortedRecords[groupIndex].records,
                                        function (record, recordIndex) {
                                          return _c(
                                            "td",
                                            {
                                              key: `sorted-rec-${recordIndex}`,
                                              staticClass: "c-table__cell",
                                              class: {
                                                "c-table__cell__move__in__company":
                                                  _vm.data.type ===
                                                  "move-in-company",
                                              },
                                            },
                                            [
                                              _vm.data.type === "main-factors"
                                                ? _c(
                                                    "c-table-main-factors-actions",
                                                    {
                                                      attrs: { record: record },
                                                    }
                                                  )
                                                : _vm._e(),
                                              _vm.data.type === "finance"
                                                ? _c(
                                                    "c-table-finance-actions",
                                                    {
                                                      attrs: { record: record },
                                                    }
                                                  )
                                                : _vm._e(),
                                              _vm.data.type ===
                                              "inventory-items-positions"
                                                ? _c(
                                                    "c-table-inventory-items-actions",
                                                    {
                                                      attrs: { record: record },
                                                    }
                                                  )
                                                : _vm._e(),
                                              _vm.data.type ===
                                                "documents-acting-documents" ||
                                              _vm.data.type ===
                                                "documents-archive"
                                                ? _c(
                                                    "c-table-documents-actions",
                                                    {
                                                      attrs: {
                                                        record: record,
                                                        "record-id": `hidden-${groupIndex}-${recordIndex}`,
                                                        "table-type":
                                                          _vm.data.type,
                                                      },
                                                      on: {
                                                        changeArchiveStatusSingle:
                                                          _vm.changeArchiveStatusSingle,
                                                      },
                                                    }
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      ),
                      _c(
                        "perfect-scrollbar",
                        {
                          staticClass:
                            "c-table__container__mobile__scrolled__td",
                          attrs: {
                            id: "tableMobileScroll" + _vm.id + groupIndex,
                            options: {
                              useBothWheelAxes: false,
                              suppressScrollX: false,
                              suppressScrollY: true,
                            },
                            tag: "div",
                          },
                          on: {
                            scroll: function ($event) {
                              return _vm.setShadowTableMobile(
                                _vm.id + groupIndex
                              )
                            },
                          },
                        },
                        [
                          _c(
                            "table",
                            { ref: "container", refInFor: true },
                            [
                              _vm._l(
                                _vm.getColumns(_vm.data.levels),
                                function (column, recordIndex) {
                                  return [
                                    column.colspan === 1
                                      ? _c(
                                          "tr",
                                          {
                                            key: `scrolled-record-${recordIndex}`,
                                            staticClass: "c-table__record",
                                          },
                                          [
                                            _c(
                                              "th",
                                              {
                                                staticClass:
                                                  "c-table__column c-table__column__mobile",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "c-table__column-wrapper c-table__column-wrapper-mobile",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "c-table__column-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              column.label
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._l(
                                              _vm.sortedRecords[groupIndex]
                                                .records,
                                              function (record, recordIndex) {
                                                return [
                                                  _c(
                                                    "td",
                                                    {
                                                      key: recordIndex,
                                                      staticClass:
                                                        "c-table__cell",
                                                      class: {
                                                        "c-table__cell__move__in__company":
                                                          _vm.data.type ===
                                                          "move-in-company",
                                                        "c-table__cell__red":
                                                          (_vm.data.type ===
                                                            "inventory-items-positions" &&
                                                            (column.id ===
                                                              "status" ||
                                                              column.id ===
                                                                "shelfLife") &&
                                                            record.status
                                                              .desc ===
                                                              "issuedoverdue") ||
                                                          (_vm.data.type ===
                                                            "documents-acting-documents" &&
                                                            column.id ===
                                                              "deadline" &&
                                                            record.expired),
                                                        "c-table__cell__yellow":
                                                          (_vm.data.type ===
                                                            "inventory-items-positions" &&
                                                            (column.id ===
                                                              "status" ||
                                                              column.id ===
                                                                "shelfLife") &&
                                                            record.status
                                                              .desc ===
                                                              "notissued") ||
                                                          (_vm.data.type ===
                                                            "documents-acting-documents" &&
                                                            column.id ===
                                                              "deadline" &&
                                                            record.expireSoon),
                                                      },
                                                    },
                                                    [
                                                      column.id === "event" &&
                                                      _vm.data.type ===
                                                        "finance"
                                                        ? _c(
                                                            "c-table-finance-event-cell",
                                                            {
                                                              attrs: {
                                                                "cell-value":
                                                                  record[
                                                                    column.id
                                                                  ].value,
                                                              },
                                                            }
                                                          )
                                                        : column.id ===
                                                            "balance" &&
                                                          _vm.data.type ===
                                                            "finance"
                                                        ? _c(
                                                            "c-table-finance-deposit-cell",
                                                            {
                                                              attrs: {
                                                                "cell-value":
                                                                  record[
                                                                    column.id
                                                                  ].value,
                                                              },
                                                            }
                                                          )
                                                        : _vm._e(),
                                                      column.id === "files" &&
                                                      _vm.isDocumentType
                                                        ? _c(
                                                            "c-table-documents-files-cell",
                                                            {
                                                              attrs: {
                                                                record: record,
                                                                "cell-value":
                                                                  record[
                                                                    column.id
                                                                  ].value,
                                                              },
                                                            }
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "c-table__cell-value",
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    record[
                                                                      column.id
                                                                    ].value
                                                                  ),
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    record[
                                                                      column.id
                                                                    ].value
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              }
                                            ),
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    _vm._l(column.colspan, function (row, ind) {
                                      return _c(
                                        "tr",
                                        {
                                          key: `record-c-${ind}-${column.id}`,
                                          staticClass: "c-table__record",
                                        },
                                        [
                                          column.colspan > 1
                                            ? [
                                                ind === 0
                                                  ? _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "c-table__column c-table__column__mobile",
                                                        attrs: {
                                                          rowspan:
                                                            column.colspan,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "c-table__column-wrapper",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "c-table__column-label",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      column.label
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._l(
                                                  _vm.sortedRecords[groupIndex]
                                                    .records,
                                                  function (
                                                    record,
                                                    recordIndex
                                                  ) {
                                                    return [
                                                      record[column.id].values[
                                                        row - 1
                                                      ].value
                                                        ? _c(
                                                            "td",
                                                            {
                                                              key: `move-in-company-cell-${recordIndex}`,
                                                              staticClass:
                                                                "c-table__cell",
                                                              class: {
                                                                "c-table__cell__move__in__company":
                                                                  _vm.data
                                                                    .type ===
                                                                  "move-in-company",
                                                              },
                                                              attrs: {
                                                                colspan:
                                                                  record[
                                                                    column.id
                                                                  ].values[
                                                                    row - 1
                                                                  ].rowspan,
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "c-table__cell-value",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      record[
                                                                        column
                                                                          .id
                                                                      ].values[
                                                                        row - 1
                                                                      ].value
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  }
                                                ),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      )
                                    }),
                                  ]
                                }
                              ),
                              _vm.data.actions
                                ? _c(
                                    "tr",
                                    {
                                      staticClass: "c-table__record",
                                      style: {
                                        height:
                                          _vm.data.type === "main-factors"
                                            ? "34px"
                                            : "",
                                      },
                                    },
                                    [
                                      _c(
                                        "th",
                                        { staticClass: "c-table__column" },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "c-table__column-empty c-table__column-empty-mobile",
                                          }),
                                        ]
                                      ),
                                      _vm._l(
                                        _vm.sortedRecords[groupIndex].records,
                                        function (record, recordIndex) {
                                          return _c(
                                            "td",
                                            {
                                              key: `move-in-company-${recordIndex}`,
                                              staticClass: "c-table__cell",
                                              class: {
                                                "c-table__cell__move__in__company":
                                                  _vm.data.type ===
                                                  "move-in-company",
                                              },
                                            },
                                            [
                                              _vm.data.type === "main-factors"
                                                ? _c(
                                                    "c-table-main-factors-actions",
                                                    {
                                                      attrs: { record: record },
                                                    }
                                                  )
                                                : _vm._e(),
                                              _vm.data.type === "finance"
                                                ? _c(
                                                    "c-table-finance-actions",
                                                    {
                                                      attrs: { record: record },
                                                    }
                                                  )
                                                : _vm._e(),
                                              _vm.data.type ===
                                              "inventory-items-positions"
                                                ? _c(
                                                    "c-table-inventory-items-actions",
                                                    {
                                                      attrs: { record: record },
                                                    }
                                                  )
                                                : _vm._e(),
                                              _vm.data.type ===
                                                "documents-acting-documents" ||
                                              _vm.data.type ===
                                                "documents-archive"
                                                ? _c(
                                                    "c-table-documents-actions",
                                                    {
                                                      attrs: {
                                                        "record-id": `mobile-${groupIndex}-${recordIndex}`,
                                                        record: record,
                                                        "table-type":
                                                          _vm.data.type,
                                                      },
                                                      on: {
                                                        changeArchiveStatusSingle:
                                                          _vm.changeArchiveStatusSingle,
                                                      },
                                                    }
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }